import { AdvancedSearch, AdvancedSearchParam } from "./User";

export interface InventoryItem {
    cartStatus: string;
    id: string;
    scanId: string;
    barcode: string;
    altCode: string;
    type: string;

    status: string;
    statusDate: string;

    accountLevel1: string;
    accountLevel2: string;
    accountLevel3: string;

    addDate: string;
    destroyDate: string;
    contentsRangeStart: string;
    contentsRangeEnd: string;
    contentsStartDate: string;
    contentsEndDate: string;

    shortDescription: string;
    longDescription: string;
    contents: string;

    setName: string;

    recordSeries: string;
    recordSeriesId: string;
    recordSeriesCode: string;
    recordSeriesTitle: string;
    legalHold: boolean;

    containerId: string;
    containerBarcode: string;
    containerAltCode: string;

    customField1: string;
    customField2: string;
    customField3: string;
    customField4: string;
    customDate: string;

    permanent: boolean;
}

export type InventoryAddItem = Omit<InventoryItem, "cartStatus">
export interface InventoryAddItemResponse {
    status: string;
    itemID?: string;
}

export type InventoryEditItem = Omit<InventoryItem, "cartStatus">

export declare type InventoryList = Array<InventoryItem>;

export interface InventoryBasicSearchParamsDateRange {
    from: string | null;
    to: string | null;
}

export enum SearchTab {
    basic = 'basic',
    advanced = 'advanced',
    file = 'file'
}

export interface InventoryBasicSearchParams {
    fullRecord:boolean;
    fullResults: boolean;
    includeLongDesc: boolean;
    includeContent: boolean;
    searchText: string | undefined;
    accountSearchText: string | null ;
    type: {
        container: boolean;
        file: boolean;
        tape: boolean;
    };
    status: {
        in: boolean;
        out: boolean;
        destroyed: boolean;
        pending: boolean;
        permout: boolean;
    };
    accounts: {
        level1: string;
        level2: string;
        level3: string;
        subfolders: boolean;
    };

    addDate: {
        from: string;
        to: string;
    };

    destroyDate: {
        from: string;
        to: string;
    };

    statusDate: {
        from: string;
        to: string;
    };

    contentsDate: {
        from: string;
        to: string;
    };

    permanent: {
        yes: boolean;
        no: boolean;
    };
}

export interface InventoryAdvancedSearchParameter {
    code: string;
    value: string;
}

export interface InventoryAdvancedSearchParams {
    code: string;
    parameters: Array<InventoryAdvancedSearchParameter>;
}

export interface InventoryFileSearchParams {
    file: string;
}

export function createDefaultBasicSearchParams(): InventoryBasicSearchParams {
    return {
        fullRecord:false,
        fullResults: false,
        includeLongDesc: false,
        includeContent: false,
        accountSearchText:"",
        searchText: "",
        type: {
            container: true,
            file: true,
            tape: true,
        },
        status: {
            in: true,
            out: true,
            destroyed: true,
            pending: true,
            permout: true,
        },
        accounts: {
            level1: "",
            level2: "",
            level3: "",
            subfolders: true,
        },

        addDate: {
            from: "",
            to: "",
        },

        destroyDate: {
            from: "",
            to: "",
        },

        statusDate: {
            from: "",
            to: "",
        },

        contentsDate: {
            from: "",
            to: "",
        },

        permanent: {
            yes: true,
            no: true,
        },
    };
}

export function createDefaultAdvancedSearchParams(searchOption: AdvancedSearch): InventoryAdvancedSearchParams {
    return {
        code: searchOption.code,
        parameters: searchOption.parameters.map((parameter: AdvancedSearchParam) => ({
            code: parameter.code,
            value: ''
        }))
    };
}
